import { Pipe, PipeTransform } from '@angular/core';
import { niveisAcademicos } from '../components/api/models/allEnums';

@Pipe({
  name: 'nivelAcademico'
})
export class NivelAcademicoPipe implements PipeTransform {

   transform(value: niveisAcademicos | string | undefined): string {
      if (value === undefined || value === null) {
        return 'Desconhecido';
      }
      return TiposnivelAcademicoDescriptions[value as niveisAcademicos] || 'Desconhecido';
    }

}

export const TiposnivelAcademicoDescriptions: { [key in niveisAcademicos]: string } = {

  [niveisAcademicos.EnsinoPrimário]: "Ensino Primário",
  [niveisAcademicos.EnsinoMedio]: "Ensino Médio",
  [niveisAcademicos.Bacharelato]: "Bacharelato",
  [niveisAcademicos.Licenciatura]: "Licenciatura",
  [niveisAcademicos.PosGraduacao]: "Pós-graduação",
  [niveisAcademicos.Mestrado]: "Mestrado",
  [niveisAcademicos.Doutoramento]: "Doutoramento",
  [niveisAcademicos.PosDoutoramento]: "Pós-Doutoramento",
  
};
